// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AuthActions } from '../../auth/duck';
import LoginPage from '../components/Login/LoginPage';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isAuthing: state.auth.isAuthing,
    authError: state.auth.authError,
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    locale: state.locale,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(AuthActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/modules/auth/containers/LoginContainer.js